module.exports = __webpack_public_path__ + "static/pitch-75a1e62d2f98eaa03d136026a3b9e173.png";